import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

/**
 * Clears any leftover SKIP_AUTO_SELECT_PROMPT latch once per JS runtime
 * (legacy silent auto-select / old dismiss path). Closer-store cooldown and
 * silent AutoSelectStore now use AUTO_SELECT_STORE_TIMESTAMP, which must
 * persist across app opens.
 */
let didResetSkipLatchForAppOpen = false;

export const resetCloserStorePromptDismissOnAppOpen = (): void => {
  if (didResetSkipLatchForAppOpen) {
    return;
  }
  didResetSkipLatchForAppOpen = true;
  syncStorage.remove(SyncStorageKey.SKIP_AUTO_SELECT_PROMPT);
};
